import {
  FormControl,
  FormErrorMessage,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { useForm, SubmitHandler } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import React, { Dispatch, useState } from "react";
import { T_ArrFilial } from "@/types/Busness";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { api } from "@/services/api";
import axios from "axios";
import { z } from "zod";
import {
  Logo,
  Form,
  Version,
  SubmitButton,
  FormInput,
  ErrorMessage,
} from "./styles";
import { Selecter } from "./selectFilials";
import { InputPassword } from "./InputPassword";
import { CTurnstile } from "./turnstile";

const signinSchema = z.object({
  login: z
    .string()
    .email("Formatação deve ser um email")
    .min(2, "Informe um usuário válido"),
  senha: z.string().min(1, "Informe a senha"),
  filial: z.string().min(1, "Informe a filial"),
});

export type SignInFormValues = z.infer<typeof signinSchema>;

interface Props {
  onSubmit: SubmitHandler<SignInFormValues>;
  error?: string;
  setNewUrl: Dispatch<string | undefined>;
}

export function SignInForm({ onSubmit, error, setNewUrl }: Props) {
  const navigate = useNavigate();

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors, isSubmitting },
    watch,
  } = useForm<SignInFormValues>({
    resolver: zodResolver(signinSchema),
  });

  const { signIn } = useAuth();

  const [filiais, setFiliais] = React.useState<T_ArrFilial>([]);
  const [urlAuth, setUrlAuth] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [token, setTokenReq] = useState<string>();
  const [tokenCloudFlare, setTokenCloudFlare] = useState<string | undefined>();

  const toast = useToast();

  async function onSubmitWhenUniqueFilial(
    credentials: SignInFormValues,
    url: string
  ) {
    return await api
      .post(
        "/auth",
        {
          login: credentials.login,
          senha: credentials?.senha,
          codfilial: credentials?.filial,
        },
        {
          headers: {
            Authorization: "Bearer " + url,
          },
        }
      )
      .then((sucess) => {
        if (!sucess) {
          toast({
            description: "Usuário ou senha incorretos",
          });
          return;
        }

        const { email, autoridades, jwt: token } = sucess.data;

        signIn(email, token, autoridades);

        navigate("/painel");
        return;
      })
      .catch((e: any) => {
        toast({
          description:
            e?.response?.data?.mensagem ||
            "Algo deu errado! Tente novamente mais tarde.",
          duration: 2000,
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
  }

  const getUrlOfUser = async () => {
    setIsLoading(true);
    try {
      const req = await axios.post(process.env.REACT_APP_API_LOGIN || "", {
        login: watch("login"),
      });

      const res = req.data;
      getFiliais(res?.jwt);
      setNewUrl(res?.jwt);
    } catch (err: any) {
      toast({
        description: err?.response?.data?.mensagem,
        duration: 2000,
      });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 2500);
    }
  };

  const getFiliais = async (url: string) => {
    setIsLoading(true);

    if (!watch("login")?.match(/\w+@+(\w)+\.+com?/)) {
      toast({
        description: "Login não atende o formato desejado.",
        duration: 2000,
      });
      setIsLoading(false);
      return;
    }

    try {
      const req = await axios.post(
        process.env.REACT_APP_API_LOGIN_FILIAL || "",
        {
          login: watch("login"),
          senha: watch("senha"),
        },
        {
          headers: {
            Authorization: "Bearer " + url,
          },
        }
      );

      const res = await req.data;

      setUrlAuth(process.env.REACT_APP_API_HOST || "");

      setFiliais(res);

      if (!(res?.length > 1)) {
        onSubmitWhenUniqueFilial(
          {
            filial: res[0]?.codfilial,
            login: watch("login"),
            senha: watch("senha"),
          },
          url
        );
        return;
      }

      setTokenReq(url);
      return;
    } catch (err: any) {
      toast({
        description:
          err?.response?.data?.mensagem || "Login ou Senha inválidos",
        duration: 2000,
      });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      error?.concat(err?.response?.data?.mensagem);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  };

  async function requestInFilial() {
    await onSubmitWhenUniqueFilial(
      {
        filial: watch("filial"),
        login: watch("login"),
        senha: watch("senha"),
      },
      token as string
    );
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Logo />

      {/* <CTurnstile setTokenCloudFlare={setTokenCloudFlare} /> */}

      {/* {(tokenCloudFlare?.length || 0) > 0 && ( */}
        <>
          <FormControl isInvalid={!!errors.login} mb={4}>
            <FormInput placeholder="Usuário" {...register("login")} />
            <FormErrorMessage color="#f1e3e3">
              {errors.login && errors.login.message}
            </FormErrorMessage>
          </FormControl>

          <InputPassword errors={errors} register={register} />
        </>
      {/* )} */}

      <Selecter data={filiais ?? []} setValue={setValue} />

      {error && <ErrorMessage>{error}</ErrorMessage>}

      {true &&
        (filiais?.length <= 0 && !urlAuth ? (
          <SubmitButton
            mt={2}
            isLoading={isSubmitting || isLoading}
            disabled={
              !((watch("login")?.length || 0) > 0) &&
              !((watch("senha")?.length || 0) > 0)
            }
            type="submit"
            onClick={getUrlOfUser}
          >
            Entrar
          </SubmitButton>
        ) : (
          filiais?.length > 1 && (
            <SubmitButton
              mt={4}
              isLoading={isSubmitting || isLoading}
              type="button"
              onClick={requestInFilial}
            >
              Entrar
            </SubmitButton>
          )
        ))}
    </Form>
  );
}
